/* Virelia Oud – theme.js : panier tiroir, paliers, upsell, quiz, popup, filtres. Aucune dépendance. */
(() => {
  const VO = window.VO || {};
  const R = VO.routes || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: VO.currency || 'EUR' });
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const imgW = (src, w) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '');
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    lget(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };
  const json = async (url, opts = {}) => {
    const res = await fetch(url, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, ...opts });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Une erreur est survenue. Réessayez.');
    return data;
  };
  function toast(msg) {
    const d = document.createElement('div');
    d.className = 'toast'; d.setAttribute('role', 'status'); d.textContent = msg;
    document.body.appendChild(d); setTimeout(() => d.remove(), 2600);
  }

  /* ---------- date de livraison ---------- */
  function deliveryDate() {
    const now = new Date();
    const d = new Date(now);
    const cutoff = Number(VO.cutoffHour || 14);
    const isBiz = (x) => x.getDay() !== 0 && x.getDay() !== 6;
    if (!(isBiz(d) && now.getHours() < cutoff)) { do { d.setDate(d.getDate() + 1); } while (!isBiz(d)); }
    let n = Number(VO.shipDays || 2);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } // Colissimo livre du lundi au samedi
    return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  const dd = deliveryDate();
  $$('[data-delivery-date]').forEach((el) => (el.textContent = dd));
  $$('[data-delivery-sentence]').forEach((el) => (el.textContent = 'Chez vous dès ' + dd + '.'));

  /* ---------- menu mobile ---------- */
  const mt = $('[data-menu-toggle]');
  mt?.addEventListener('click', () => {
    const nav = $('#mobileNav'); nav.hidden = !nav.hidden; mt.setAttribute('aria-expanded', String(!nav.hidden));
  });

  /* ---------- panier tiroir ---------- */
  const drawer = $('#cartDrawer');
  let lastFocus = null;
  function setBadge(n) { $$('[data-cart-badge]').forEach((b) => (b.textContent = n)); }
  function tierMsg(count) {
    const tiers = (VO.tiers || []).filter((t) => t.n > 0).sort((a, b) => a.n - b.n);
    const next = tiers.find((t) => count < t.n);
    const got = [...tiers].reverse().find((t) => count >= t.n);
    if (next) {
      const k = next.n - count;
      return `Ajoutez <b>${k} produit${k > 1 ? 's' : ''}</b> pour obtenir <b>−${next.pct} %</b> sur toute la commande`;
    }
    return got ? `<b>−${got.pct} %</b> appliqués sur toute votre commande` : '';
  }
  async function upsell(cart) {
    const first = cart.items[0];
    if (!first || !R.recommendations) return '';
    try {
      const data = await json(`${R.recommendations}.json?product_id=${first.product_id}&limit=8&intent=related`);
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const left = Math.max(0, VO.freeShipping - cart.total_price);
      const list = (data.products || [])
        .filter((p) => !inCart.has(p.id) && p.available)
        .sort((a, b) => (left > 0 ? Math.abs(a.price - left) - Math.abs(b.price - left) : 0))
        .slice(0, 3);
      if (!list.length) return '';
      const count = cart.item_count;
      const next = (VO.tiers || []).find((t) => count < t.n);
      return `<div class="ups"><span class="eyebrow">${next ? `Ajoutez-en un pour −${next.pct} %` : 'Complétez votre collection'}</span>${list
        .map((p) => {
          const v = p.variants.find((x) => x.available) || p.variants[0];
          return `<div class="up"><a class="thumb" href="${p.url}">${p.featured_image ? `<img src="${imgW(p.featured_image, 120)}" alt="" loading="lazy">` : ''}</a><div class="min0"><b>${esc(p.title.split(' – ')[0])}</b><small class="hint num">${money(p.price)}</small></div><button class="ghost sm" type="button" data-up-add="${v.id}">+ Ajouter</button></div>`;
        })
        .join('')}</div>`;
    } catch (e) { return ''; }
  }
  async function renderCart() {
    const cart = await json(`${R.cart}.js`);
    setBadge(cart.item_count);
    if (!drawer) return cart;
    $('[data-cart-count]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
    const body = $('[data-cart-body]', drawer);
    const goals = $('[data-cart-goals]', drawer);
    const foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      goals.hidden = true; foot.hidden = true;
      body.innerHTML = `<div class="empty">Votre panier est vide.<br><br><a class="cta" href="${R.root}collections/all">Explorer la collection</a><br><br><a class="link" href="${R.root}pages/quiz">ou trouvez votre parfum avec le quiz</a></div>`;
      return cart;
    }
    const left = Math.max(0, VO.freeShipping - cart.total_price);
    goals.hidden = false; foot.hidden = false;
    $('[data-ship-msg]', drawer).innerHTML = left > 0 ? `Plus que <b class="num">${money(left)}</b> pour la livraison offerte` : '<b>Livraison offerte</b> débloquée';
    $('[data-ship-bar]', drawer).style.width = Math.min(100, (cart.total_price / VO.freeShipping) * 100) + '%';
    $('[data-tier-msg]', drawer).innerHTML = tierMsg(cart.item_count);
    body.innerHTML = cart.items
      .map((i) => `<div class="line"><a class="thumb" href="${i.url}">${i.image ? `<img src="${imgW(i.image, 160)}" alt="" loading="lazy">` : ''}</a>
        <div class="min0"><a class="n" href="${i.url}">${esc(i.product_title)}</a>${i.variant_title && i.variant_title !== 'Default Title' ? `<br><small class="hint">${esc(i.variant_title)}</small>` : ''}
          <div class="qty" style="margin-top:6px"><button type="button" data-line="${i.key}" data-q="${i.quantity - 1}" aria-label="Moins">−</button><span class="num">${i.quantity}</span><button type="button" data-line="${i.key}" data-q="${i.quantity + 1}" aria-label="Plus">+</button></div>
          <button class="rm" type="button" data-line="${i.key}" data-q="0">Retirer</button></div>
        <b class="num">${money(i.final_line_price)}</b></div>`)
      .join('');
    $('[data-cart-sub]', drawer).textContent = money(cart.items_subtotal_price);
    const disc = cart.items_subtotal_price - cart.total_price;
    $('[data-cart-disc-row]', drawer).hidden = disc <= 0;
    $('[data-cart-disc]', drawer).textContent = '−' + money(disc);
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    upsell(cart).then((html) => { if (html) body.insertAdjacentHTML('beforeend', html); });
    return cart;
  }
  function openCart() {
    if (!drawer) { location.href = R.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false; document.body.style.overflow = 'hidden';
    renderCart().catch((e) => toast(e.message));
    $('[data-cart-close].iconbtn', drawer)?.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.hidden = true; document.body.style.overflow = '';
    lastFocus?.focus?.();
  }
  async function addItems(items, btn) {
    btn?.setAttribute('aria-busy', 'true');
    try {
      await json(`${R.cartAdd}.js`, { method: 'POST', body: JSON.stringify({ items }) });
      openCart();
    } catch (e) { toast(e.message); }
    finally { btn?.removeAttribute('aria-busy'); }
  }

  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches('[data-ajax-add]')) return;
    e.preventDefault();
    const fd = new FormData(f);
    addItems([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], f.querySelector('[type=submit]') || e.submitter);
  });

  document.addEventListener('click', async (e) => {
    const t = e.target.closest('[data-cart-open],[data-cart-close],[data-line],[data-up-add],[data-pair-add],[data-qty],[data-welcome-close],.thumbs img');
    if (!t) return;
    if (t.matches('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.matches('[data-cart-close]')) { closeCart(); return; }
    if (t.matches('[data-line]')) {
      try { await json(`${R.cartChange}.js`, { method: 'POST', body: JSON.stringify({ id: t.dataset.line, quantity: Number(t.dataset.q) }) }); renderCart(); }
      catch (err) { toast(err.message); }
      return;
    }
    if (t.matches('[data-up-add]')) { addItems([{ id: Number(t.dataset.upAdd), quantity: 1 }], t); return; }
    if (t.matches('[data-pair-add]')) { addItems(JSON.parse(t.dataset.pairAdd), t); return; }
    if (t.matches('[data-qty]')) {
      const input = t.parentElement.querySelector('[data-qty-input]');
      input.value = Math.max(1, Math.min(10, Number(input.value || 1) + Number(t.dataset.qty)));
      return;
    }
    if (t.matches('[data-welcome-close]')) { closeWelcome(); return; }
    if (t.matches('.thumbs img')) {
      const main = $('.main-pic img');
      if (main && t.dataset.full) { main.srcset = ''; main.src = t.dataset.full; }
      $$('.thumbs img').forEach((i) => i.classList.toggle('on', i === t));
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); closeWelcome(); } });

  /* ---------- fiche produit : souvent acheté avec + barre collante ---------- */
  const pair = $('[data-pair]');
  if (pair && R.recommendations) {
    json(`${R.recommendations}.json?product_id=${pair.dataset.productId}&limit=4&intent=related`).then((data) => {
      const p = (data.products || []).find((x) => x.available);
      const mainId = Number($('#product-form [name=id]')?.value);
      if (!p || !mainId) return;
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const t1 = (VO.tiers || [])[0];
      pair.innerHTML = `<span class="eyebrow">Souvent acheté avec</span>
        <div class="pair-row"><a class="thumb" href="${p.url}">${p.featured_image ? `<img src="${imgW(p.featured_image, 120)}" alt="" loading="lazy">` : ''}</a><div class="min0"><b>${esc(p.title.split(' – ')[0])}</b><br><small class="hint">${money(p.price)}</small></div></div>
        <button class="ghost pair-add" type="button" data-pair-add='${JSON.stringify([{ id: mainId, quantity: 1 }, { id: v.id, quantity: 1 }])}'>Ajouter les deux${t1 ? ` · −${t1.pct} % appliqués` : ''}</button>`;
      pair.hidden = false;
    }).catch(() => {});
  }
  const sticky = $('[data-stickybuy]');
  const mainAdd = $('[data-main-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }).observe(mainAdd);
  }

  /* ---------- recommandations (section) ---------- */
  const recos = $('[data-recos]');
  if (recos && !recos.children.length) {
    fetch(recos.dataset.url).then((r) => r.text()).then((html) => {
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recos]');
      if (el && el.innerHTML.trim()) recos.innerHTML = el.innerHTML;
    }).catch(() => {});
  }

  /* ---------- filtres de collection ---------- */
  const filters = $('[data-filters]');
  if (filters) {
    let tm;
    filters.addEventListener('change', () => filters.requestSubmit ? filters.requestSubmit() : filters.submit());
    filters.addEventListener('input', (e) => { if (e.target.type === 'number') { clearTimeout(tm); tm = setTimeout(() => filters.submit(), 900); } });
    $('[data-sort]')?.addEventListener('change', (e) => { filters.querySelector('[name=sort_by]').value = e.target.value; filters.submit(); });
    $('[data-filters-toggle]')?.addEventListener('click', () => filters.classList.toggle('open'));
  }

  /* ---------- popup de bienvenue ---------- */
  const wel = $('[data-welcome]');
  function openWelcome(force) {
    if (!wel || (!force && (store.get('vo-welcome') || store.lget('vo-subscribed')))) return;
    if (drawer && !drawer.hidden) return;
    store.set('vo-welcome', '1');
    wel.hidden = false; document.body.style.overflow = 'hidden';
  }
  function closeWelcome() { if (wel && !wel.hidden) { wel.hidden = true; document.body.style.overflow = ''; } }
  if (wel) {
    if ($('[data-welcome-success]', wel)) { store.lset('vo-subscribed', '1'); openWelcome(true); }
    else {
      setTimeout(() => openWelcome(false), Number(wel.dataset.delay || 25) * 1000);
      document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth > 900) openWelcome(false); });
    }
  }
  if (/customer_posted=true/.test(location.search)) store.lset('vo-subscribed', '1');

  /* ---------- quiz ---------- */
  const quiz = $('[data-quiz]');
  if (quiz) {
    const stage = $('[data-quiz-stage]', quiz);
    const A = { who: '', mood: '', budget: '' };
    const MOODS = {
      oud: { l: 'Boisé & oudé', s: 'Intense, sombre, élégant', re: /oud|wood|black|asad|dukhan|tabac|tobacco|leather|noir|sheikh|fursan|khanjar|ambre|amber/i },
      gourmand: { l: 'Sucré & gourmand', s: 'Vanille, café, épices chaudes', re: /khamrah|qahwa|caf[ée]|vanill|gourmand|choco|sugar|miel|honey|caramel|mallow|candy|sweet|cerise|cherry|plum/i },
      musk: { l: 'Musqué & doux', s: 'Propre, poudré, peau', re: /musc|musk|white|abiyedh|abiyeh|pure|velvet|cashmere|silk|clean/i },
      floral: { l: 'Floral & fruité', s: 'Rose, fleurs, fruits', re: /rose|yara|flower|fleur|jasmin|bloom|eclaire|\bher\b|fiora|garden|peach|berry/i },
    };
    const STEPS = [
      { k: 'who', q: 'Pour qui est ce parfum ?', o: [['Femme', 'Pour elle'], ['Homme', 'Pour lui'], ['Mixte', 'Mixte'], ['any', 'Peu importe']] },
      { k: 'mood', q: 'Quelle ambiance vous attire ?', o: [...Object.entries(MOODS).map(([k, v]) => [k, v.l, v.s]), ['any', 'Je ne sais pas encore']] },
      { k: 'budget', q: 'Quel budget pour un flacon ?', o: [['low', 'Moins de 25 €'], ['mid', '25 à 40 €'], ['high', 'Plus de 40 €'], ['any', 'Peu importe']] },
    ];
    let catalog = null;
    async function loadCatalog() {
      if (catalog) return catalog;
      const h = quiz.dataset.collection || 'all';
      const out = [];
      for (let page = 1; page <= 4; page++) {
        const d = await json(`${R.root}collections/${h}/products.json?limit=250&page=${page}`);
        out.push(...(d.products || []));
        if (!d.products || d.products.length < 250) break;
      }
      catalog = out.filter((p) => p.variants.some((v) => v.available) && !/coffret|ambiance|d[ée]odorant/i.test(p.product_type));
      return catalog;
    }
    function score(p) {
      const tags = (p.tags || []).map((t) => t.toLowerCase());
      const text = (p.title + ' ' + tags.join(' ')).toLowerCase();
      const price = Number(p.variants.find((v) => v.available)?.price || p.variants[0].price);
      let s = 0;
      if (A.who && A.who !== 'any') {
        if (tags.includes(A.who.toLowerCase())) s += 3;
        else if (tags.includes('mixte')) s += 1.5;
        else s -= 5;
      }
      if (A.mood && A.mood !== 'any' && MOODS[A.mood].re.test(text)) s += 4;
      const b = { low: [0, 25], mid: [25, 40], high: [40, 1e6] }[A.budget] || [0, 1e6];
      s += price >= b[0] && price < b[1] ? 3 : -2;
      return s;
    }
    function card(p) {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const img = p.images?.[0]?.src;
      const cmp = Number(v.compare_at_price || 0), pr = Number(v.price);
      return `<article class="card"><a class="pic" href="${R.root}products/${p.handle}">${img ? `<img src="${imgW(img, 500)}" alt="${esc(p.title)}" loading="lazy">` : ''}${cmp > pr * 1.1 ? `<span class="off">−${Math.round((1 - pr / cmp) * 100)} %</span>` : ''}</a>
        <div class="body"><span class="brand">${esc(p.vendor)}</span><a class="name" href="${R.root}products/${p.handle}">${esc(p.title.split(' – ')[0])}</a><span class="meta">${esc(p.product_type)}</span>
        <div class="price"><b class="num">${money(Math.round(pr * 100))}</b>${cmp > pr ? `<s class="num">${money(Math.round(cmp * 100))}</s>` : ''}</div></div>
        <form class="quick" data-ajax-add><input type="hidden" name="id" value="${v.id}"><input type="hidden" name="quantity" value="1"><button class="addq" type="submit">Ajouter au panier</button></form></article>`;
    }
    function show(step) {
      if (step < STEPS.length) {
        const st = STEPS[step];
        stage.innerHTML = `<span class="eyebrow num">Question ${step + 1} sur ${STEPS.length}</span>
          <div class="bar" style="max-width:320px"><i style="width:${((step + 1) / STEPS.length) * 100}%"></i></div>
          <h1 class="h-xl">${st.q}</h1>
          <div class="qopts">${st.o.map(([v, l, s]) => `<button class="qopt" type="button" data-qa="${st.k}" data-v="${v}"><b>${l}</b>${s ? `<span>${s}</span>` : ''}</button>`).join('')}</div>
          ${step ? `<button class="link" type="button" data-qback="${step - 1}">← Question précédente</button>` : ''}`;
        loadCatalog().catch(() => {});
        return;
      }
      stage.innerHTML = '<p class="quiz-loading">Nous cherchons vos parfums…</p>';
      loadCatalog().then((list) => {
        const res = list.map((p) => ({ p, s: score(p) })).sort((a, b) => b.s - a.s).slice(0, 6).map((x) => x.p);
        const t1 = (VO.tiers || [])[0], t2 = (VO.tiers || [])[1];
        stage.innerHTML = `<div class="sec-head quiz-results"><div><span class="eyebrow">Votre sélection</span><h1 class="h-xl">Les parfums faits pour vous</h1>${t1 ? `<p class="hint">Prenez-en ${t1.n} pour −${t1.pct} %${t2 ? `, ${t2.n} pour −${t2.pct} %` : ''}.</p>` : ''}</div><button class="ghost" type="button" data-qback="0">Recommencer</button></div>
          <div class="grid quiz-results">${res.map(card).join('') || '<div class="empty">Aucun parfum disponible pour l’instant.</div>'}</div>`;
      }).catch(() => { stage.innerHTML = `<div class="empty">Le catalogue n’a pas pu être chargé. <a class="link" href="${R.root}collections/all">Voir tous les parfums</a></div>`; });
    }
    quiz.addEventListener('click', (e) => {
      const t = e.target.closest('[data-quiz-start],[data-qa],[data-qback]');
      if (!t) return;
      if (t.matches('[data-quiz-start]')) show(0);
      else if (t.matches('[data-qa]')) { A[t.dataset.qa] = t.dataset.v; show(STEPS.findIndex((s) => s.k === t.dataset.qa) + 1); }
      else show(Number(t.dataset.qback));
      quiz.scrollIntoView({ block: 'start' });
    });
  }

  /* état initial du badge (cache navigateur) */
  if (drawer) json(`${R.cart}.js`).then((c) => setBadge(c.item_count)).catch(() => {});
})();
